import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/transitional/components/View';
import UIRouterLink from 'ui-addon-react-router-dom/UIRouterLink';
import { Paths } from '../../constants/paths';
import { StorefrontNav } from '../../navigation/components/StorefrontNav';
import { SearchBar } from '../../search-bar/components/SearchBar';
import { ManageBuildDropdowns } from './ManageBuildDropdowns';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function HomepageHeader() {
  return /*#__PURE__*/_jsxs(View, {
    "data-test-id": "homepage-header",
    paddingBlock: "600",
    position: "relative",
    children: [/*#__PURE__*/_jsx(ManageBuildDropdowns, {}), /*#__PURE__*/_jsx(UIRouterLink, {
      to: Paths.HOME,
      use: "unstyled",
      children: /*#__PURE__*/_jsx(Text, {
        as: "h1",
        typography: "heading-600",
        marginBlockEnd: "400",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplaceStorefront.headers.title"
        })
      })
    }), /*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      flexWrap: "wrap",
      columnGap: "1000",
      rowGap: "500",
      justifyContent: "space-between",
      children: [/*#__PURE__*/_jsx(View, {
        flexShrink: 0,
        children: /*#__PURE__*/_jsx(StorefrontNav, {})
      }), /*#__PURE__*/_jsx(View, {
        maxInlineSize: "600px",
        minInlineSize: "400px",
        flexGrow: 1,
        children: /*#__PURE__*/_jsx(SearchBar, {})
      })]
    })]
  });
}